"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AccessTokenManager {
    constructor(props = { url: '', options: {} }) {
        this.get = () => {
            if (this.expiresAt > Date.now() && this.cachedToken) {
                return this.cachedToken;
            }
            this.expiresAt = Infinity;
            this.cachedToken = fetch(this.url, this.options)
                .then(response => {
                if (response.ok) {
                    return response
                        .json()
                        .then(json => {
                        this.expiresAt = Date.now() + json.expires_in * 1000 * 0.9;
                        return json.access_token;
                    }).catch(error => {
                        const out = {
                            error,
                            response,
                        };
                        return Promise.reject(out);
                    });
                }
                if (response.status === 401) {
                    return Promise.resolve().then(() => {
                        this.expiresAt = 0;
                        return;
                    });
                }
                this.cachedToken = undefined;
                this.expiresAt = 0;
                const out = {
                    error: null,
                    response,
                };
                return Promise.reject(out);
            });
            return this.cachedToken;
        };
        this.clear = () => {
            this.cachedToken = undefined;
            this.expiresAt = 0;
        };
        this.url = props.url;
        this.options = Object.assign({}, props.options, { headers: Object.assign({ Accept: 'application/json' }, (props.options && props.options.headers || {})) });
        this.cachedToken = undefined;
        this.expiresAt = 0;
    }
}
AccessTokenManager.createUser = (clientId) => new AccessTokenManager({
    url: `https://generic.wg.spotify.com/creator-auth-proxy/v1/web/token?client_id=${clientId}`,
    options: { credentials: 'include' },
});
AccessTokenManager.createAnonymous = (clientId) => new AccessTokenManager({
    url: 'https://generic.wg.spotify.com/creator-auth-proxy/api/token',
    options: { method: 'POST', body: `client_id=${clientId}&grant_type=client_credentials` },
});
exports.AccessTokenManager = AccessTokenManager;
//# sourceMappingURL=AccessTokenManager.js.map